import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LaTagComponent} from './la-tag.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [LaTagComponent],
  exports: [LaTagComponent]
})
export class LaTagModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: LaTagModule,
      providers: []
    };
  }
}
